@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.flags
import com.narbase.letsgo.dto.core.KmmLong

data class FlagDto (
        var id: KmmLong?,
        val carTypeId: Int?,
        val maxPerDay: Int,
        val percentage: Double,
        val flagThreshold: Double,
        val profileGroupId: Int?,
        val driverId: KmmLong?,
        val noDestination: Boolean
)